import { useCallback } from 'react';
import type { MumulLiveProfileStatus } from 'shared/src/api';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

type LiveProfileBadgeLogParams = {
  /** market.mumul_live_profile_sno */
  profileSno: number;
  profileName: string;
  status: MumulLiveProfileStatus;
  /** LIVE 일 때만 값이 있고 스토리는 null */
  campaignSno: number | null;
};

const TYPE = 'MUMUL_LIVE';

/**
 * 상품상세 무물라이브 프로필(간판) 노출·클릭 로깅.
 * 마켓홈(#2039)과 동일한 이벤트/파라미터를 상품상세 로거로 발화한다.
 * SCREEN 등 상품상세 defaults 는 useLogGoodsAnalyticsEvent 가 주입한다.
 */
export const useLogMumulLiveProfileBadge = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  const buildAnalytics = ({
    profileSno,
    profileName,
    status,
    campaignSno,
  }: LiveProfileBadgeLogParams) => ({
    PROFILE_SNO: profileSno.toString(),
    PROFILE_NAME: profileName,
    PROFILE_STATUS: status,
    CAMPAIGN_SNO: campaignSno != null ? campaignSno.toString() : null,
    TYPE,
  });

  const logDisplayLiveProfileBadge = useCallback(
    (params: LiveProfileBadgeLogParams) => {
      logGoodsAnalytics({
        name: 'DISPLAY_LIVE_PROFILE_BADGE',
        analytics: buildAnalytics(params),
      });
    },
    [logGoodsAnalytics],
  );

  const logClickLiveProfileBadge = useCallback(
    (params: LiveProfileBadgeLogParams) => {
      logGoodsAnalytics({
        name: 'CLICK_LIVE_PROFILE_BADGE',
        analytics: buildAnalytics(params),
      });
    },
    [logGoodsAnalytics],
  );

  return { logDisplayLiveProfileBadge, logClickLiveProfileBadge };
};
